import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { fromJS } from 'immutable';
import UserCard from '../UserCard';

export default class Step2 extends PureComponent {
    render() {
        const { userForm, handleUser } = this.props;
        return (
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid container item md={12} lg={6} xl={4}>
                    <UserCard user={fromJS(userForm)} readyToEdit noCancel modeAdd addUserFunc={handleUser} />
                </Grid>
            </Grid>
        );
    }
}

Step2.propTypes = {
    userForm: PropTypes.object.isRequired,
    handleUser: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/components/stepper/Step2.js